import FullCalendar, { EventClickArg } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction"; // needed for dayClick //
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import { useStyles } from "./styles";

type SchedulerProps = {
  events: any[];
  onEventClick?: (arg: EventClickArg) => void;
  onDateClick?: (arg: DateClickArg) => void;
};

export function Scheduler({
  events,
  onDateClick,
  onEventClick,
}: SchedulerProps) {
  const styles = useStyles();

  return (
    <FullCalendar
      dayMaxEventRows={2}
      eventClassNames={styles.event}
      dateClick={onDateClick}
      eventClick={onEventClick}
      events={events}
      headerToolbar={{
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
      }}
      plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      locale={ptBrLocale}
    />
  );
}
